export default function Contact() {
    return(
       <div className="container">
         <h1>This is Contact Us page</h1>
       </div>
    )

}